import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PAGELENGTH } from 'components/common/ListLayout';
import Api from "services/api"
import { logout } from './userSlice';


export const initialState = {
    accessList: [],
    permissionList: [],
    error: null,
    loader: false,
    featured: {},
    current_page: 1,
    per_page: PAGELENGTH
}

export const permissionSlice = createSlice({
    name: 'permission',
    initialState: initialState,
    reducers: {
        setAccessesState: (state, { payload }) => {
            state.accessList = payload?.data ?? payload;
        },
        setAccessesStates: (state, { payload }) => {
            state.accessList = payload;
        },
        setPermission: (state, { payload }) => {
            state.permissionList = payload?.data ?? payload;
            state.total = payload?.total;
            state.is_more = payload?.is_more;
            state.last_page = payload?.last_page;
            state.current_page = payload?.current_page;
            state.per_page = payload?.per_page;
        },
        setPermissions: (state, { payload }) => {
            state.permissionList = payload?.data;
            state.total = payload?.total;
            state.is_more = payload?.is_more;
            state.last_page = payload?.last_page;
            state.current_page = payload?.current_page;
            state.per_page = payload?.per_page;
        },
        clearAllDashboard: (state, { payload }) => {
            state.loader = payload
        },
        setError: (state, { payload }) => {
            state.error = payload
        },
        setLoader: (state, { payload }) => {
            state.loader = payload
        },
    }
})


export const fetchAccessesList = (disableLoader) => async (dispatch) => {
    !disableLoader && dispatch(setLoader(true))
    try {
        const result = await Api.fetchAccessesList()
        if (result.status >= 200 && result.status < 300) {
            dispatch(setAccessesStates(result.data.data));
        }
        else if (result?.status == 422) {
            dispatch(setError(result.data))
        }
        else if (result?.status == 401) {
            dispatch(setError("Unauthorized"))
            dispatch(logout())
        }
    } catch (error) {
        console.log("error", error)
    }
    !disableLoader && dispatch(setLoader(false))
}

export const addPermissionGroup = (data, callback) => async (dispatch) => {
    const apiService = new Api();
    dispatch(setError({}))
    dispatch(setLoader(true))
    try {

        const json = await Api.addPermissionGroup(data)
        if (json.status >= 200 && json.status < 300) {
            console.log(json)
            callback(true, json.data.message)
        } else if (json.status == 422) {
            dispatch(setError(json.data))
            callback(false, json.data.message)
        }
    } catch (error) {
        console.log(error)

    }
    dispatch(setLoader(false))
}

export const updatePermissionGroup = (data, itemId, callback) => async (dispatch) => {
    const apiService = new Api();
    dispatch(setError({}))
    dispatch(setLoader(true))
    try {

        const json = await Api.updatePermissionGroup(data, itemId)
        if (json.status >= 200 && json.status < 300) {
            console.log(json)
            callback(true, json.data.message)
        } else if (json.status == 422) {
            dispatch(setError(json.data))
            callback(false, json.data.message)
        }
    } catch (error) {
        console.log(error)
    }
    dispatch(setLoader(false))
}

export const removePermissionGroup = (itemId, callback) => async (dispatch) => {
    const apiService = new Api();
    dispatch(setError({}))
    dispatch(setLoader(true))
    try {
        const json = await Api.removePermissionGroup(itemId)
        if (json.status >= 200 && json.status < 300) {
            console.log(json)
            callback(true, json.data.message)
        } else if (json.status == 422) {
            dispatch(setError(json.data))
            callback(false, json.data.message)
        }
    } catch (error) {
        console.log(error)
    }
    dispatch(setLoader(false))
}
export const changeStatus = (id, data) => async (dispatch) => {
    const apiService = new Api();
    dispatch(setError({}))
    dispatch(setLoader(true))
    try {
        const json = await Api.statusChange(id, data, 'permissions/groups')
        if (json.status >= 200 && json.status < 300) {
        } else if (json.status == 422) {
            dispatch(setError(json.data))
        }
    } catch (error) {
        console.log(error)
    }
    dispatch(setLoader(false))
}

export const removeMultiplePermissionGroup = (ids, callback) => async (dispatch) => {
    const apiService = new Api();
    dispatch(setError({}))
    dispatch(setLoader(true))
    try {
        const json = await Api.removeMultiplePermissionGroup(ids)
        if (json.status >= 200 && json.status < 300) {
            console.log(json)
            callback(true, json.data.message)
        } else if (json.status == 422) {
            dispatch(setError(json.data))
            callback(false, json.data.message)
        }
    } catch (error) {
        console.log(error)
    }
    dispatch(setLoader(false))
}

export const fetchPermissionGroupList = (page, params, disableLoader, Aync) => async (dispatch) => {
    !disableLoader && dispatch(setLoader(true))
    try {
        const result = await Api.fetchPermissionGroupList(page, params)
        if (result.status >= 200 && result.status < 300) {
            if (page > 1) {
                if (Aync) {
                    return result?.data?.data;
                } else {
                    dispatch(setPermissions(result.data.data));
                    !disableLoader && dispatch(setLoader(false))
                }
            } else {
                if (Aync) {
                    return result?.data?.data;
                } else {
                    dispatch(setPermissions(result.data.data));
                    !disableLoader && dispatch(setLoader(false))
                }
            }
        }
        else if (result?.status == 422) {
            if (Aync) {
                return [];
            } else {
                dispatch(setError(result.data))
                !disableLoader && dispatch(setLoader(false))
            }
        }
        !disableLoader && dispatch(setLoader(false))
    } catch (error) {
        console.log("error", error)
    }
}

export const { setAccessesStates, clearAllDashboard, setPermissions, setLoader, setError } = permissionSlice.actions

export default permissionSlice.reducer
export const PermissionSelector = state => state.permission



